export default {
  name: 'marking--atkForBroker',
  urlParamName: 'marking--atkForBroker',
};